export default __webpack_public_path__ + "static/media/03n.1701d316.svg";